var addthis_config;
// Navigation, Search, Sticky Footer, etc.
(function($, undef) {
  $(document).ready(function(){
    // Navigation
    $('#nav-toggle').on('touchstart click', function(e){
      e.preventDefault();

      //Prevent against handling a click immediately after touchstart.
      if(e.type == "click" && $(this).data("lastTouch") == "touchstart"){
        e.stopImmediatePropagation();
        return false;
      }
      $(this).data("lastTouch", e.type);

      $('.nav-bar').toggleClass('active');
    });

    // Search Wildcards
    $('form.search-bar').bind('submit', function(e){
      var data = {};
      $.each($(this).serializeArray(), function(){
        data[this.name] = this.value;
      });

      if(data.q && data.q.length){
        e.preventDefault();
        data.q = data.q.replace(/([^ ]{3,}$)/, "$1*");
        window.location = "/search?"+$.param(data);
      }
    });

    // Cart promotion tracking
    Shop.trackPromos();
  });

  // Sticky Footer
  var adjustFooter = function(){
    var w = $(window).height(),
        b = $(document.body).height(),
        f = $('.site-footer'),
        fh = f.outerHeight(true);

    if( f.hasClass('stuck') && ( w < (b + fh)) ) {
      f.removeClass('stuck');
    }else if( !f.hasClass('stuck') && ( w > b ) ) {
      f.addClass('stuck');
    }
  };

  $(window).load(adjustFooter);
  $(window).resize(adjustFooter);

})(jQuery);

// General Shop Methods
var Shop;
(function($, undef){
  Shop = {
    // Used for JS only event tracking not tied to an HTML element with a default action.
    trackEvent: function(opts={}){
      if(typeof(opts) != 'object'){ // Allow old multi-argument format
        opts = {
          category: arguments[0], 
          action: arguments[1], 
          label: arguments[2], 
          value: arguments[3], 
          callback: arguments[4]
        };
      }

      if(typeof ga === "undefined"){
        if(opts.callback) opts.callback();
        return true; // Return true unless ga object exists.
      }

      opts = {
        'hitType': 'event',
        'eventCategory': opts.category,
        'eventAction': opts.action,
        'eventLabel': opts.label,
        'eventValue': opts.value,
        'hitCallback': opts.callback
      };

      ga('send', opts);
    },

    // Used as an event handler for a button or form that has a default action you want to continue after tracking the event.
    trackEventAndContinue: function(e){
      try {

        if(typeof ga === "undefined") return true; // Return true unless ga object exists.
        if($(e.target).data("eventTracked")) return; // Return true if we have already handled the GA event tracking.

        e.preventDefault();
        if((this.disabled !== undef && this.disabled) || $(this).hasClass('disabled')) return false;

        var opts = {
          'hitType': 'event',
          'eventCategory': e.data.category,
          'eventAction': e.data.action,
          'eventLabel': e.data.label,
          'eventValue': e.data.value,
          'hitCallback': function(){
            Shop.triggerDefaultEvent(e);
          }
        };
        ga('send', opts);

      }catch(err){
        return Shop.triggerDefaultEvent(e);
      }

    },

    triggerDefaultEvent: function(e){
      $(e.target).data("eventTracked", true);
      if(e.type == "click" && e.target.href){
        window.location.href = e.target.href;
      }else{
        $(e.target).trigger(e.type);
      }
      return true;
    },

    parseQueryParams: function(){
      Shopify.queryParams = {};
      if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]).replace(/\+/g, ' ');
          }
        }
      }
      return Shopify.queryParams;
    },

    trackPromos : function(){
      var params = {};
      $.each(window.location.search.substr(1).split("&"), function(i,v){
        var p = v.split('=');
        if (p.length != 2) return;
        params[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
      });
      if(!("cp" in params)) return;

      var data = { attributes : {
        'Promoted products' : params.cp
      }};

      $.ajax({
        url: '/cart/update.js',
        type: 'POST',
        dataType: 'json',
        data: data
      });
    }
  };

  Shop.Modal = {
    existing: null,

    open: function(html){
      var modal = this.existing;

      html = $("<div></div>").addClass('modal-content').html(html);

      if(!modal){
        modal = $("<div></div>").addClass('modal');
        $(document.body).append(modal);
        $(document).keyup(function(e) {
          if (e.keyCode === 27) Shop.Modal.close(); // ESC
        });
        modal.on('click', '.modal-close', this.close);
      }

      modal.addClass('closed');
      setTimeout(function(){
        modal.html(html).removeClass('closed');
      }, 1);

      return (this.existing = modal);
    },

    close: function(){
      Shop.Modal.existing.addClass('closed');
    }
  };
})(jQuery);

function waitForElement(selector) {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        const el = Array.from(mutation.addedNodes || []).find(node => node.nodeType == 1 && node.matches(selector));
        if(el) {
          resolve(el);
          observer.disconnect();
        }
      });
    });

    observer.observe((document.documentElement || document.body), {
      childList: true,
      subtree: true
    });
  });
}

// Extend jQuery
(function($){
  $.getScript = function(url, callback, cache){
    return $.ajax({
      type: "GET",
      url: url,
      success: callback,
      dataType: "script",
      cache: cache
    });
  };

  $.keys = function(obj){
    return $.map(obj, function(o, key){ return key; });
  };
}(jQuery));

// Prototyping
(function(){
  Date.parseISO = function(isoString){
    var parts = isoString.match(/\d+/g),
        isoTime = Date.UTC(parts[0], parts[1] - 1, parts[2], parts[3] || null, parts[4] || null, parts[5] || null);
    d = new Date(isoTime);
    return d;
  };

  Date.prototype.utc = function(){
    return new Date(this.getUTCFullYear(), this.getUTCMonth(), this.getUTCDate(),  this.getUTCHours(), this.getUTCMinutes(), this.getUTCSeconds());
  };

  Date.monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  Date.prototype.getMonthName = function(){ return Date.monthNames[this.getMonth()]; };
  Date.prototype.getUTCMonthName = function(){ return Date.monthNames[this.getUTCMonth()]; };

  Date.monthAbbreviations = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  Date.prototype.getMonthAbbreviation = function(){ return Date.monthAbbreviations[this.getMonth()]; };
  Date.prototype.getUTCMonthAbbreviation = function(){ return Date.monthAbbreviations[this.getUTCMonth()]; };

  Date.weekdays = {1:"Monday",2:"Tuesday",3:"Wednesday",4:"Thursday",5:"Friday"};
  Date.prototype.isWeekday = function(){ return (this.getDay() in Date.weekdays); };

  String.toSlug = function(str){
    return str
      .replace(/^\s*|\s*$/g, "") // Strip string
      .replace(/['`]|/, "") // Strip apostraphes
      .replace(/\s*[^\w\-]\s*/g, "-") // Replace non alpha or hyphen characters with hyphen
      .replace(/-+/g, '-') // Replace multiple hyphens with single
      .toLowerCase();
  };

  String.prototype.toSlug = function(){ return String.toSlug(this); };
}());

